import Joi from "joi";

export const assetSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  barcode: Joi.string()
    .pattern(/^[0-9]+$/)
    .min(2)
    .label("Barcode")
    .messages({
      "string.pattern.base": '"Barcode" must contain only numbers',
    }),
  isDefault: Joi.boolean().label("Is Default"),
  description: Joi.string().min(2).label("Description"),
  assetCategoryId: Joi.string().min(2).label("AssetCategoryId"),
  assetTypeId: Joi.string().min(2).label("AssetType"),
  vendorId: Joi.string().min(2).label("Vendor"),
  locationId: Joi.string().allow("").label("Location"),
  assetDepartmentId: Joi.string().min(2).label("AssetDepartment"),
  assetStatusId: Joi.string().min(2).label("AssetStatus"),
  price: Joi.number().min(0).label("Price"),
  companyId: Joi.string().min(2).invalid("00000000-0000-0000-0000-000000000000").required().label("Company"),
  customerId: Joi.string().allow("").label("Customer"),
});
